
import * as lodash from 'lodash'

let translations = {}
let i18n = { t: k => k }

function isObject (val) {
    return (typeof val) === 'object' && val != null
}

function interpolate (task, key) {
    let rv = key

    if (task.level > task.maxLevel) {
        return rv
    }

    if (isObject(task.data)) {
        rv = key.replace(/\{((?:[_\-0-9A-Za-z]+)(?:\.[_\-0-9A-Za-z]+)*)\}/g, function (_1_, match) {
            return task.data[match] || ''
        })
    }

    return rv.replace(/@:((?:[_0-9A-Za-z]+)(?:\.[_0-9A-Za-z]+)*)/g, function (_1_, match) {
        ++task.level

        const _rv_ = _$t_(task, match)

        --task.level

        return _rv_
    })
}

function setI18n (i18nObject) {
    i18n = i18nObject
}

function hasTranslation (key) {
    if (translations[key] != null) {
        return true
    }

    const value = i18n.t(key)
    return key !== value
}

function getTranslation (keyToTranslate, data) {
    return $t(translations, keyToTranslate, data)
}

function setTranslations (stringObject) {
    const newTranslationObject = lodash.merge(translations, stringObject)
    translations = newTranslationObject
}

function $t (content, key, data) {
    if (!isObject(content) || key == null || key === false || key === true || key === '') {
        return ''
    }

    const task = {
        level: 1,
        maxLevel: 64,
        content,
        data
    }

    return _$t_(task, String(key))
}

function _$t_ (task, key) {
    if (task.content[key] != null) {
        return interpolate(task, String(task.content[key]))
    }

    const stringKeys = key.split('.')
    let translationHolder = task.content
    let i = 0
    while (i < stringKeys.length) {
        if (translationHolder[stringKeys[i]] != null) {
            translationHolder = translationHolder[stringKeys[i]]
        } else {
            translationHolder = false
            break
        }
        i++
    }

    if (translationHolder) {
        return interpolate(task, translationHolder)
    }

    return i18n.t(key, task.data)
}

export default {
    setI18n,
    hasTranslation,
    getTranslation,
    setTranslations,
    $t
}
